import React, { useState } from "react";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import classes from "./ContentBody.module.css";

const DeleteBody = (props) => {
  const { userList, pageNumber, usersPerPage, pageCount } = props;
  const users = userList.users || [];
  const changePage = ({ selected }) => {
    props.onChangePageNumber(selected);
  };
  const [sortBy, setSortBy] = useState("createDate");
  const [sortType, setSortType] = useState(true);
  const sortClick = (key) => {
    props.onChangeSortClick(key);
    setSortBy(key);
    if (sortType) {
      setSortType(false);
    } else {
      setSortType(true);
    }
    props.onChangeSortType(sortType);
  };
  let count = pageNumber + 1;
  if (count > 1) {
    count = usersPerPage * pageNumber + 1;
  }

  const handleSearch = async (e) => {
    props.onSearchChang(e.target.value);
  };

  const setSelectedOption = (e) => {
    props.onPerPageChange(e.target.value);
  };

  const displayUsers = users.map((val, i) => {
    return (
      <React.Fragment key={Math.random(1, 9999)}>
        <tr>
          {/* <td>{count++}</td> */}
          <td>{val.name}</td>
          <td>{val.email}</td>
          <td>{val.createDate}</td>
          <td>{val.lastLoginDate}</td>
          <td>{val.deleteDate}</td>
          {/* <td>
            {val.status === 1 ? (
              <span
                className="badge badge-success badge-lg light"
                onClick={() => {
                  userStatusChange(val._id, 0);
                }}
              >
                Active
              </span>
            ) : (
              <span
                className="badge badge-danger badge-lg light"
                onClick={() => {
                  userStatusChange(val._id, 1);
                }}
              >
                InActive
              </span>
            )}
          </td> */}
          <td className="text-center">
            <div className="action-buttons d-flex justify-content-center">
              <Link
                className="btn btn-secondary light mr-2"
                to={`/admin/edit-user/${val._id}`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  className="svg-main-icon"
                >
                  <g
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x={0} y={0} width={24} height={24} />
                    <path
                      d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                      fill="#000000"
                      fillRule="nonzero"
                      transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                    ></path>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x={5}
                      y={20}
                      width={15}
                      height={2}
                      rx={1}
                    />
                  </g>
                </svg>
              </Link>
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  });

  const showingEntries = () => {
    let testTotal = pageNumber + 1;
    let startnumber = (testTotal - 1) * usersPerPage + 1;
    let endnumber =
      testTotal * usersPerPage > testTotal - 1 * usersPerPage
        ? testTotal * 1 * usersPerPage
        : testTotal * usersPerPage;
    if (endnumber > userList.totalUsers) {
      endnumber = userList.totalUsers;
    }
    return (
      "Showing " +
      startnumber +
      " to " +
      endnumber +
      " of " +
      userList.totalUsers +
      " records"
    );
  };

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4 flex-wrap">
            <h4 className="fs-20 font-w600  me-auto">Deleted Users List</h4>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="table-responsive">
                <div
                  id="example_wrapper"
                  className="dataTables_wrapper d-flex justify-content-between"
                >
                  <div className="dataTables_length" id="example_length">
                    <label>
                      Show
                      <select
                        name="example_length"
                        aria-controls="example"
                        onChange={setSelectedOption}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      entries
                    </label>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div id="example_filter" className="dataTables_filter mx-4">
                      <input
                        type="search"
                        className="form-control"
                        aria-controls="example"
                        placeholder="Search..."
                        onKeyDown={(e) => e.key === "Enter" && handleSearch(e)}
                      />
                    </div>
                  </div>
                </div>
                <table
                  className="table display mb-4 dataTablesCard job-table table-responsive-xl card-table"
                  id={classes["users-list-main"]}
                >
                  <thead>
                    <tr>
                      <th
                        onClick={() => {
                          sortClick("name");
                        }}
                      >
                        Name
                        {sortBy === "name" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "name" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      <th
                        onClick={() => {
                          sortClick("email");
                        }}
                      >
                        Email
                        {sortBy === "email" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "email" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      <th
                        onClick={() => {
                          sortClick("createDate");
                        }}
                      >
                        Joined Date
                        {sortBy === "createDate" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "createDate" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      <th
                        onClick={() => {
                          sortClick("lastLogin");
                        }}
                      >
                        Last Login
                        {sortBy === "lastLogin" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "lastLogin" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      <th
                        onClick={() => {
                          sortClick("lastLogin");
                        }}
                      >
                        Deleted Date
                        {sortBy === "lastLogin" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "lastLogin" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      {/* <th
                        onClick={() => {
                          sortClick("status");
                        }}
                      >
                        Status
                        {sortBy === "status" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "status" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th> */}
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length > 0 && displayUsers}
                    {users.length === 0 && (
                      <tr>
                        <td colSpan="6">
                          <div className="text-center">
                            <h4>Sorry!</h4>
                            <h5>No users Found.</h5>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="sm-mb-0 mb-3">
                  <h5>{showingEntries()}</h5>
                </div>
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageCount={pageCount}
                  onPageChange={changePage}
                  containerClassName="pagination pagination-circle"
                  previousClassName="page-item page-indicator"
                  previousLinkClassName="page-link"
                  nextClassName="page-item page-indicator"
                  nextLinkClassName="page-link"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                />
              </div>

              {/* <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="sm-mb-0 mb-3">
                  <h5 className="mb-0">Showing 5 of 102 Data</h5>
                </div>
                <nav>
                  <ul className="pagination pagination-circle">
                    <li className="page-item page-indicator"><a className="page-link" href="javascript:void(0)">Prev</a></li>
                    <li className="page-item active"><a className="page-link" href="javascript:void(0)">1</a></li>
                    <li className="page-item page-indicator"><a className="page-link" href="javascript:void(0)">Next</a></li>
                  </ul>
                </nav>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DeleteBody;
